<template>
    <div
        role="alert"
        class="alert alert-danger p-3 m-0 mt-3">
        <div class="d-flex justify-content-between">
            <div>
                <h4 class="alert-heading">
                    {{ header }}
                </h4>
                <div v-if="subheader">
                    {{ subheader }}
                </div>
            </div>
            <button
                v-if="suppressible"
                class="btn-close align-self-start ms-2"
                aria-label="Suppress"
                type="button"
                v-on:click="$emit('suppress')"></button>
        </div>
        <hr />
        <div
            v-for="(group, groupIndex) in groups"
            v-bind:key="'validation-error-group' + groupIndex"
            v-bind:data-test-role="group.testRole">
            {{ group.heading }}
            <ul>
                <li
                    v-for="(error, index) in group.errors"
                    v-bind:key="getErrorKey(group, error, index)">
                    <div v-if="group.descriptionOnly">
                        {{ getErrorPrimary(group, error) }}
                    </div>
                    <div v-else>
                        <span v-bind:id="getErrorDescribedById(groupIndex, index)">
                            <strong>{{ getErrorPrimary(group, error) }}</strong>
                            {{ getErrorSecondary(group, error) }} -
                        </span>
                        <pc-button
                            style="min-width: 0"
                            class="p-0"
                            link
                            v-bind:aria-describedby="getErrorDescribedById(groupIndex, index)"
                            v-on:click="$emit('error-link', { group, error })">
                            {{ error.buttonLabel }}
                        </pc-button>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            header: { type: String, required: true },
            subheader: { type: String, required: false, default: "" },
            groups: { type: Array, required: true },
            suppressible: { type: Boolean, required: false, default: false }
        },
        emits: ["suppress", "error-link"],
        methods: {
            getErrorKey(group, error, index) {
                return group.keyProp ? error[group.keyProp] : index;
            },
            getErrorPrimary(group, error) {
                return group.descriptionOnly || !group.primaryProp ? error.Description : error[group.primaryProp];
            },
            getErrorSecondary(group, error) {
                return group.secondaryProp ? `: ${error[group.secondaryProp]}` : "";
            },
            getErrorDescribedById(groupIndex, index) {
                return `${groupIndex}-${index}-error`;
            }
        }
    };
</script>
